module.exports = __webpack_public_path__ + "static/media/biteship-shopify.768bf989.png";